<template>
<div>
  <vx-card ref="listCard" :title="$t('MRMR.Statement.Title')"  class="mb-3" title-color="black" refresh-content-action @refresh="getStatements" >
   <vs-row vs-type="flex" vs-justify="flex-end">
      <vs-col vs-type="flex"  vs-justify="center" vs-align="center" vs-w="2">
        <form-label class="m-2">{{$t('MRMR.Statement.Period')}}</form-label>
        <v-select
          label="name"
          :options="filteredPeriods"
          :reduce="item => item.id"
          v-model="queryPeriodId"
          name="queryPeriod"
          class="w-full"
        />
      </vs-col>
      <vs-col vs-type="flex"  vs-justify="right" vs-align="end" vs-w="1" class="pb-2">
        <feather-icon icon="PlusCircleIcon" class="cursor-pointer" svg-classes="h-6 w-6" @click="addNewData" v-b-tooltip.hover :title="$t('AddNew')" />
        <feather-icon icon="PrinterIcon" class="cursor-pointer ml-5" svg-classes="h-6 w-6" @click="openReport" v-if="$auth.checkRoles(mrmrRoles.consolidation)" v-b-tooltip.hover :title="$t('MRMR.Statement.Report')" />
      </vs-col>
    </vs-row>
    <ag-grid-vue
      ref="agGridTable"
      :components="components"
      :gridOptions="gridOptions"
      :context="context"
      class="ag-theme-material w-100 my-4 ag-grid-table"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="statementList"
      :rowClassRules="rowClassRules"
      rowSelection="multiple"
      colResizeDefault="shift"
      :animateRows="true"
      :pagination="false"
      :suppressPaginationPanel="true"
      :enableCellChangeFlash="false"
      :enableRtl="$vs.rtl"/>
  </vx-card>
  <vs-prompt
    :title="$t('MRMR.Statement.Reject')"
    @cancel="cancelReject"
    @accept="rejectStatement"
    @close="cancelReject"
    :active.sync="activeRejectPrompt">
    <div class="con-exemple-prompt">
      <span>{{ $t('MRMR.Statement.ConfirmReject')}}</span>
      <vs-input :placeholder="$t('MRMR.Statement.Reason')" :vs-placeholder="$t('MRMR.Statement.Reason')" v-model="reason" class="mt-3 w-full" />
    </div>
  </vs-prompt>
  <vs-prompt
    :title="$t('MRMR.Statement.Duplicate')"
    :is-valid="isPeriodSelected"
    @cancel="cancelDuplication"
    @accept="duplicateStatement"
    @close="cancelDuplication"
    :active.sync="activeDuplicationPrompt">
    <div class="con-exemple-prompt">
      <form-label>{{$t('MRMR.Statement.SelectTargetPeriod')}}</form-label>
      <ValidationProvider :name="$t('MRMR.Statement.Period')" rules="required" v-slot="{ errors }">
         <v-select
              label="name"
              :options="sortedPeriods"
              :reduce="item => item.id"
              v-model="statementPeriodId"
              class="w-full"
              name="periodId"
            />
        <validation-message>{{ errors[0] }}</validation-message>
      </ValidationProvider>
    </div>
  </vs-prompt>
  <vs-prompt
    :title="$t('MRMR.Statement.Renew')"
    :is-valid="isCommentsDefined"
    @cancel="cancelRenew"
    @accept="renewStatement"
    @close="cancelRenew"
    :active.sync="activeRenewPrompt">
    <div class="con-exemple-prompt">
      <form-label>{{$t('MRMR.Statement.SelectTargetPeriod')}}</form-label>
      <ValidationProvider :name="$t('MRMR.Statement.Period')" rules="required" v-slot="{ errors }">
        <v-select
              label="name"
              :options="sortedPeriods"
              :reduce="item => item.id"
              v-model="statementPeriodId"
              class="w-full"
              name="periodId"
            />
        <validation-message>{{ errors[0] }}</validation-message>
      </ValidationProvider>
      <form-label>{{$t('MRMR.Statement.Notes')}}</form-label>
      <ValidationProvider :name="$t('MRMR.Statement.Notes')" rules="required" v-slot="{ errors }">
        <vs-textarea 
          v-model="selectedComments" 
          class="w-full"  
          height="300px"
          name="comments" />
        <validation-message>{{ errors[0] }}</validation-message>
      </ValidationProvider>
    </div>
  </vs-prompt>
  <vs-popup :title="$t('MRMR.Statement.SubmissionNotes')"   :active.sync="activeSubmissionNotesPrompt">
    <div class="con-exemple-prompt">
      <vs-progress v-show="fetchHistoryInProgress" indeterminate color="primary">primary</vs-progress>
      <vx-status :data="statusData" />
    </div>
  </vs-popup>
  <vs-popup :title="$t('MRMR.Statement.VersionsTitle')" :active.sync="activeVersionsPrompt">
    <div class="con-exemple-prompt">
      <vs-progress v-show="fetchVersionsInProgress" indeterminate color="primary">primary</vs-progress>
      <statement-versions :data="versionsData" 
        @onViewVersion="viewVersion" 
        @onPromoteVersion="openPromoteVersionPrompt"/>
    </div>
  </vs-popup>
  <vs-prompt
    :title="$t('MRMR.Statement.PromoteVersionTitle')"
    @cancel="cancelPromoteVersion"
    @accept="promoteVersion"
    @close="cancelPromoteVersion"
    :active.sync="activePromoteVersionPrompt">
    <div class="con-exemple-prompt">
      <vs-row class="mb-5">
        <span>{{ $t('MRMR.Statement.ConfirmPromoteVersion')}}</span>        
      </vs-row>
      <form-label>{{$t('MRMR.Statement.Notes')}}</form-label>
      <ValidationProvider :name="$t('MRMR.Statement.Notes')" rules="required" v-slot="{ errors }">
        <vs-textarea 
          v-model="selectedComments" 
          class="w-full"  
          height="300px"
          name="comments" />
        <validation-message>{{ errors[0] }}</validation-message>
      </ValidationProvider>
    </div>
  </vs-prompt>
</div>

</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";

import Vue from "vue";
import router from '../../../../router'
import moduleMRMR from "../store/moduleMRMR.js";
import vSelect from 'vue-select';
import mrmrRoles from './../roles.js'

import VxStatus from '@/components/audit/VxStatus'
import StatementVersions from './components/StatementVersions'
import StatementActionsCellRenderer from './components/StatementActionsCellRenderer.vue'
import StatementVersionsCellRenderer from './components/StatementVersionsCellRenderer.vue'
import StatementComparison from './components/StatementComparison.vue'
import shared from '../../../shared/SharedFunctions.js'
import qpOccupationsEnum from "../QPOccupationEnum";

import featureFlagsService from '@/app/shared/services/featureFlagsService.js'
import features from "@/app/shared/AppFeatures.js"

import {
  ValidationMessage,
  FormLabel
} from "../../../shared/components";

export default {
  /* eslint-disable vue/no-unused-components */
  components: {
    AgGridVue,
    StatementActionsCellRenderer,
    StatementComparison,
    vSelect,
    ValidationMessage,
    FormLabel,
    VxStatus,
    StatementVersions
  },
  data() {
    return {
      mrmrRoles,
      /* prompts */
      activeRejectPrompt:false,
      activeDuplicationPrompt:false,
      activeRenewPrompt: false,
      activeSubmissionNotesPrompt: false,
      activeVersionsPrompt: false,
      activePromoteVersionPrompt:  false,


      statusData: [],
      versionsData: [],
      fetchHistoryInProgress : false,
      fetchVersionsInProgress : false,
      reason: '',
      selectedStatementId : null,
      selectedProjectId: null,
      selectedStatement: null,
      statementPeriodId: null,
      statementProjectId: null,
      selectedComments: null,
      isMounted: false,
      queryPeriodId: null,

      defaultColDef: {
        sortable: true,
        resizable: true,
        editable: (params) => {
          return params.data.approbationDate === null
        }
      },
      gridApi: null,
      gridOptions: {
        onCellValueChanged: (params) => {
          this.updateForecast(params.data);
        },
        getRowNodeId: (data) => {
          return data.id;
        }
      },
      rowClassRules: {
        'statement-submitted': 'data.isSubmitted',
        'statement-approved': 'data.isApproved'
      },
      context: { componentParent: this },
      columnDefs: [
        {
          headerName: 'Actions',
          field: 'id',
          width: 235,
          editable: false,
          sortable: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          cellRendererFramework: Vue.extend(StatementActionsCellRenderer)
        },
        {
          headerName: this.$t('MRMR.Statement.Project'),
          field: "projectName",
          width: 200,
          filter:'agTextColumnFilter'
        },
        {
          headerName: this.$t('MRMR.Statement.Period'),
          field: "periodName",
          width: 150,
          filter:'agTextColumnFilter'
        },
        {
          headerName: this.$t('MRMR.Statement.Version'),
          field: "version",
          width: 135,
          editable: false,
          sortable: true,
          filter:'agTextColumnFilter',
          cellRendererFramework: Vue.extend(StatementVersionsCellRenderer)
        },
        {
          headerName: this.$t('MRMR.Statement.QPEngineering'),
          field: "qpEngineering",
          width: 300,
          filter:'agTextColumnFilter',
          valueGetter: (params) => {
            if (params.data.engineerQPId) {
              const qpsAllowedForProject = this.$store.state.mrmr.qps.filter(p => p.occupation === qpOccupationsEnum.Engineer && p.allowedProjects.map(z => z.projectId).includes(this.selectedProjectId));
              const qp = qpsAllowedForProject.find(p => p.id === params.data.engineerQPId);
              if (qp) return qp.name;
            } else {
              const user = this.$store.state.mrmr.qpEngineeringUsers.find(p => p.userPrincipalName === params.data.qpEngineering);
              if (user)
                return user.displayName;
            }
            if (params.data.qpEngineering) return params.data.qpEngineering;
            return "";
          }
        },
        {
          headerName: this.$t('MRMR.Statement.QPGeology'),
          field: "qpGeology",
          width: 300,
          filter:'agTextColumnFilter',
          valueGetter: (params) => {
            if (params.data.geologistQPId) {
              const qpsAllowedForProject = this.$store.state.mrmr.qps.filter(p => p.occupation === qpOccupationsEnum.Geologist && p.allowedProjects.map(z => z.projectId).includes(this.selectedProjectId));
              const qp = qpsAllowedForProject.find(p => p.id === params.data.geologistQPId);
              if (qp) return qp.name;
            }
            else {
              const user = this.$store.state.mrmr.qpGeologyUsers.find(p => p.userPrincipalName === params.data.qpGeology);
              if (user)
                return user.displayName;
            }

            if (params.data.qpGeology) return params.data.qpGeology;
            return "";
          }
        },
        {
          headerName: this.$t('MRMR.Statement.Ownership'),
          field: "ownership",
          filter:'agNumberColumnFilter'
        }
      ],
      components: {
        StatementActionsCellRenderer
      }
    };
  },

  computed: {
    statementList() {
      if (this.queryPeriodId !== null) {
        return this.$store.state.mrmr.statements.filter(s => s.mrmrStatementPeriodId === this.queryPeriodId);
      } else {
        return this.$store.state.mrmr.statements;
      }
    },
    periods() {
      return this.$store.state.mrmr.periods;
    },
    filteredPeriods() {
      const all = this.periods.map((x) => x).sort((a, b) => { return (a.periodDate > b.periodDate) ? -1 : 1 });
      all.unshift({ id:null, name: this.$t('MRMR.Period.SelectAll') });
      return all;
    },
    sortedPeriods() {
      const existingPeriods = this.$store.state.mrmr.statements.filter(s => s.projectId === this.statementProjectId).map(s => s.mrmrStatementPeriodId);
      const list =  this.periods.filter(i => !existingPeriods.includes(i.id))
      return list.sort((a, b) => { return (a.periodDate < b.periodDate) ? -1 : 1 });
    },
    isPeriodSelected() {
      return this.statementPeriodId !== '' && this.statementPeriodId !== null;
    },
    isCommentsDefined() {
      return this.selectedComments !== '' && this.selectedComments !== null;
    },
    qpEngineeringApprovalEnabled() {
      if (!features.Geo) return false;
      if (!features.Geo.MRMR) return false;
      return featureFlagsService.isEnabled(features.Geo.MRMR.QpEngineeringApproval)
    }
  },

  mounted() {
    this.gridApi = this.gridOptions.api;
    
    if (this.$store.state.mrmr.periods.length === 0 || 
        this.$store.state.mrmr.qpEngineeringUsers.length === 0 ||
        this.$store.state.mrmr.qpGeologyUsers.length === 0 ||
        this.$store.state.mrmr.qps.length === 0 ||
        this.$store.state.mrmr.projects.length === 0) {
      this.$vs.loading();

      Promise.all([
        this.$store.dispatch("mrmr/fetchPeriodListItems"),
        this.$store.dispatch("mrmr/fetchAllProjects"),
        this.$store.dispatch("mrmr/fetchQPGeologyGroupUsers"),
        this.$store.dispatch("mrmr/fetchQPEngineeringGroupUsers"),
        this.$store.dispatch("mrmr/fetchQPListItems")
      ]).then(() => {
        if (!this.isMounted) {
          this.$refs.listCard.refreshcard();
        }

        this.isMounted = true;

      }).finally(() => {
        this.$vs.loading.close();
      })
    } 
    else {
      if (!this.isMounted) {
        this.$refs.listCard.refreshcard();
      }

      this.isMounted = true;
    }
  },

  created() {
    if (!moduleMRMR.isRegistered) {
      this.$store.registerModule("mrmr", moduleMRMR);
      moduleMRMR.isRegistered = true;
    }
    
    this.selectedProjectId = Number(this.$store.state.projectId);
    if (this.$route.params.periodId !== undefined && this.$route.params.periodId !== null) {
      this.queryPeriodId = this.$route.params.periodId;
    } else if (this.$store.state.mrmr.selectedPeriodId !== null) {
      this.queryPeriodId = this.$store.state.mrmr.selectedPeriodId;
    }
  },  
  watch: {
    queryPeriodId() {
      this.$store.dispatch("mrmr/updateSelectedPeriodId", this.queryPeriodId)
      this.$refs.listCard.refreshcard()
    }
  },
  methods: {
    addNewData() {
      router.push({ name: 'mrmr-statements-edit', params: { editData: null} });
    },
    editData(data) {
      router.push({ name: 'mrmr-statements-edit', params: { editData: data } });
    },
    viewData(data) {
      router.push({ name: 'mrmr-statements-view', params: { selectedStatement: data } });
    },
    viewVersion(data, isLatest) {

      this.$vs.loading();

      this.activeVersionsPrompt = false;

      // hack to show loading screen
      shared.sleep(1000).then(() => {
        this.$vs.loading.close();
        router.push({ name: 'mrmr-statements-view', params: { selectedStatement: data, isLatestVersion: isLatest } });
      });
      
    },
    openPromoteVersionPrompt(data) {      
      this.selectedComments = null;
      this.activeVersionsPrompt = false;      
      this.selectedStatementId = data.id;
      this.activePromoteVersionPrompt = true;      
    },
    cancelPromoteVersion() {      
      this.selectedComments = null;
      this.selectedStatementId = null;
      this.activePromoteVersionPrompt = false; 
    },
    promoteVersion() {
      this.activePromoteVersionPrompt = false;      
      if (this.selectedStatementId !== null) {
        this.$cqrsPost('geo/mrmr/statements/promoteVersion/', {
          id : this.selectedStatementId,
          notes : this.selectedComments})
          .then(() => {
            this.$notifySuccess(this.$t('MRMR.Statement.PromoteVersionSuccess'));
            this.$refs.listCard.refreshcard();
          });
      } 
    },
    openReport() {
      router.push({ name: 'mrmr-statements-report' });
    },
    getStatements() {
      this.$store.dispatch("mrmr/fetchStatementListItems", this.selectedProjectId).finally(() => {
        this.$refs.listCard.removeRefreshAnimation();
      }); 
    },
    deleteData(id) {
      this.$store.dispatch("mrmr/removeStatement", id)
        .then(() => {
          this.$vs.notify({
            color: "success",
            title: this.$t("Success"),
            text: this.$t("MRMR.Statement.StatementDeleted")
          });
        });
    },

    submitStatement(id) {
      this.$cqrsPost('geo/mrmr/statements/submit/', { id })
        .then(() => {
          this.$notifySuccess(this.$t('MRMR.Statement.SubmitSuccess'));
          this.$refs.listCard.refreshcard();
        });
    },
    cancelSubmission(id) {
      this.$cqrsPost('geo/mrmr/statements/cancel/', { id })
        .then(() => {
          this.$notifySuccess(this.$t('MRMR.Statement.CancelSubmissionSuccess'));
          this.$refs.listCard.refreshcard();
        });
    },
    
    openRejectPrompt(id) {
      this.reason = ""; 
      this.selectedStatementId = id;
      this.activeRejectPrompt = true;
    },
    cancelReject() {
      this.selectedStatementId = null;
      this.reason = ''; 
    },
    rejectStatement() {
      if (this.selectedStatementId !== null) {
        this.$vs.loading();
        this.$cqrsPost('geo/mrmr/statements/reject/', {
          id : this.selectedStatementId,
          reason : this.reason})
          .then(() => {
            this.$notifySuccess(this.$t('MRMR.Statement.RejectSuccess'));
            this.$refs.listCard.refreshcard();            
            this.$vs.loading.close();
          });
      }
    },
    openDuplicatePrompt(id) {
      this.selectedStatementId = id;      
      this.statementProjectId = this.statementList.filter(i => i.id === this.selectedStatementId)[0].projectId;
      this.activeDuplicationPrompt = true;
    },
    cancelDuplication() {
      this.selectedStatementId = null;
      this.statementPeriodId = null;
    },
    openRenewPrompt(id) {
      this.selectedStatementId = id;
      this.statementProjectId = this.statementList.filter(i => i.id === this.selectedStatementId)[0].projectId;
      this.activeRenewPrompt = true;
      this.statementPeriodId = null;
      this.selectedComments = null;
    },
    cancelRenew() {
      this.selectedStatementId = null;
      this.selectedComments = null;
      this.statementPeriodId = null;
    },
    openSubmissionNotes(id) {
      this.selectedStatementId = id;
      this.activeSubmissionNotesPrompt = true;

      this.fetchHistoryInProgress = true;
      this.$cqrsGet('geo/mrmr/statements/FindSubmissionHistory',  { params: {id} })
        .then((response) => {
          const model = response.data.model;
          if (response.status === 200) {            
            this.fetchHistoryInProgress = false;
            this.statusData = model;
          }
        }).catch((error) => {
          this.$notifyLoadingError(error.message);
        });
    },
    openVersionsPopup(id) {
      this.selectedStatementId = id;
      this.activeVersionsPrompt = true;

      this.fetchVersionsInProgress = true;
      this.$cqrsGet('Geo/MRMR/Statements/GetStatementVersions/', { params: { id } })
        .then((response) => {
          if (response.status === 200) {            
            this.fetchVersionsInProgress = false;
            this.versionsData = response.data.model;
          }
        }).catch((error) => {
          this.$notifyLoadingError(error.message);
        });
    },
    cancelSubmissionNotes() {
      this.selectedStatementId = null;
    },
    duplicateStatement() {
      this.$vs.loading();
      this.$cqrsPost('geo/mrmr/statements/duplicate/', {
        statementId : this.selectedStatementId,
        targetPeriodId : this.statementPeriodId})
        .then(() => {
          this.$notifySuccess(this.$t('MRMR.Statement.DuplicateSuccess'));
          this.$refs.listCard.refreshcard();
          this.$vs.loading.close();
        });
    },
    renewStatement() {
      this.$vs.loading();
      this.$cqrsPost('geo/mrmr/statements/renew/', {
        statementId : this.selectedStatementId,
        targetPeriodId : this.statementPeriodId,
        comments : this.selectedComments})
        .then(() => {
          this.$notifySuccess(this.$t('MRMR.Statement.RenewSuccess'));
          this.$refs.listCard.refreshcard();
          this.$vs.loading.close();
        });
    },
    approveStatement(id) {
      this.$vs.loading();
      this.$cqrsPost('geo/mrmr/statements/approve/', { id })
        .then(() => {
          this.$notifySuccess(this.$t('MRMR.Statement.ApprovalSuccess'));
          this.$refs.listCard.refreshcard();          
          this.$vs.loading.close();
        });
    },
    approveStatementByEngineering(id) {
      this.$vs.loading();
      this.$cqrsPost('geo/mrmr/statements/approveByEngineering/', { id })
        .then(() => {
          this.$notifySuccess(this.$t('MRMR.Statement.ApprovalByEngineeringSuccess'));
          this.$refs.listCard.refreshcard();          
          this.$vs.loading.close();
        });
    }
  }
};
</script>
<style lang="scss">
.comparisonPopup {
    .vs-popup {
      width: 1400px !important;
    }
  } 

.statement-submitted {
  border-width: 1 !important;
  border-style: solid !important;
  border-color:  #ffcc00 !important;
}

.statement-approved {
  border-width: 1 !important;
  border-style: solid !important;
  border-color:  #339900 !important;
}
</style>
